// This import loads the firebase namespace along with all its type information.
import PurchasableItem from './purchasable-item-model'

export async function load_purchasableItems(): Promise<PurchasableItem[]> {
  throw 'Not implemented'
}

export async function delete_purchasableItem(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_purchasableItem(): Promise<PurchasableItem> {
  throw 'Not implemented'
}
